import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { PostalServiceField, CityField, PostalPointField } from "./Fields";

export function ServicePointTypeFields() {
  const { watch } = useFormContext();
  const deliveryType = watch("delivery_type");
  const hasServicePointType = deliveryType === 2;

  if (!hasServicePointType) {
    return null;
  }

  return (
    <>
      <Grid item xs={12}>
        <PostalServiceField />
      </Grid>
      <Grid item xs={12}>
        <CityField />
      </Grid>
      <Grid item xs={12}>
        <PostalPointField />
      </Grid>
    </>
  );
}
